import Flash from '@/components/flash';
import WorkspaceShell from '@/components/workspace-shell';
import type { Breadcrumb } from '@/types/breadcrumb';
import type { WorkspacePageProps } from '@/types';
import { Head, usePage } from '@inertiajs/react';

interface WorkspaceLayoutProps {
  children: React.ReactNode;
  flash: {
    notice?: string;
    error?: string;
  };
  pageTitle?: string;
  breadcrumbs?: Breadcrumb[];
  sidebarOpen?: boolean;
}

export default function WorkspaceLayout({
  children,
  flash,
  pageTitle,
  breadcrumbs,
}: WorkspaceLayoutProps) {
  const { props } = usePage<
    WorkspacePageProps & { pageTitle?: string; breadcrumbs?: Breadcrumb[] }
  >();
  const { auth } = props;
  const currentPath = props.currentPath as string;
  const appVersion = props.appVersion as string;
  const title = pageTitle || props.pageTitle || 'Iorio';
  const crumbs = breadcrumbs ?? props.breadcrumbs ?? [];

  return (
    <>
      <Head title={title} />
      <div className="iorio-workspace-frame min-h-dvh w-full">
        <WorkspaceShell
          currentPath={currentPath}
          auth={auth}
          appVersion={appVersion}
          breadcrumbs={crumbs}
        >
          <Flash {...flash} />
          {children}
        </WorkspaceShell>
      </div>
    </>
  );
}
